import { useCookies } from 'react-cookie'
import { decryptPhoneNumber } from 'src/utils'
import { Bridge } from 'src/utils/bridge'

const useCustomCookies = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, _setCookie, removeCookie] = useCookies([
    'trans-id', //가입 인증
    'auth-key',
    'u-tel',
    'req_num', //pass 인증
    'pin_check', //핀체크 중복화면 방지
    'app_install_popup', //웹 앱설치 유도 팝업
  ])

  const removeAllCookies = () => {
    //앱에 저장된 정보 삭제
    Bridge.handleReqDeleteInfo()
    //쿠키 삭제
    removeCookie('trans-id', { path: '/' })
    removeCookie('auth-key', { path: '/' })
    removeCookie('u-tel', { path: '/' })
    removeCookie('req_num', { path: '/' })
    removeCookie('pin_check', { path: '/' })
    removeCookie('app_install_popup', { path: '/' })
  }

  return {
    c_tel: !!cookies['u-tel'] ? (decryptPhoneNumber(cookies['u-tel']) as string) : '',
    c_transId: cookies['trans-id'] as string,
    c_authKey:
      cookies['auth-key'] !== 'undefined' && !!cookies['auth-key']
        ? (cookies['auth-key'] as string)
        : '',
    removeAllCookies,
  }
}
export default useCustomCookies
